import { Dispatch } from "redux";
import { UserActionTypes, UserAction } from "./User";
import { Entitlement, EntitlementKind } from "@blacknut/javascript-sdk/dist";
import { getEntitlements } from "@blacknut/javascript-sdk/dist/api/BlacknutPlus/getEntitlements";

export const getSubscription = () => {
  return (dispatch: Dispatch<UserAction>) => {
    return new Promise<Entitlement | undefined>((resolve, reject) => {
      dispatch({
        type: UserActionTypes.FETCH_ENTITLEMENTS_REQUEST,
      });
      getEntitlements().subscribe({
        next: (entitlements) => {
          const mainEntitlement = entitlements.find(
            (e) => e.kind === EntitlementKind.MAIN,
          );
          dispatch({
            type: UserActionTypes.FETCH_ENTITLEMENTS_SUCCESS,
            entitlements,
          });
          resolve(mainEntitlement);
        },
        error: (error) => {
          dispatch({
            type: UserActionTypes.FETCH_ENTITLEMENTS_ERROR,
            error,
          });
          reject(error);
        },
      });
    });
  };
};
